import { render } from "./UpgradePlansModal.vue?vue&type=template&id=54744082&ts=true"
import script from "./UpgradePlansModal.vue?vue&type=script&lang=ts"
export * from "./UpgradePlansModal.vue?vue&type=script&lang=ts"

import "./UpgradePlansModal.vue?vue&type=style&index=0&id=54744082&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__